export default __webpack_public_path__ + "static/media/Jordan Hunsaker.8e66f03f.jpeg";